module.exports = __webpack_public_path__ + "82e013b35760ffe0fc830f41fd71430c.pdf";